import {
    FETCH_ECG_RECORDING_LIST_START,
    FETCH_ECG_RECORDING_LIST_SUCCESS,
    FETCH_ECG_RECORDING_LIST_FAIL,
    FETCH_MORE_ECG_RECORDING_LIST_SUCCESS,
    DELETE_ECG_RECORDING_START,
    DELETE_ECG_RECORDING_SUCCESS,
    DELETE_ECG_RECORDING_FAIL,
    UPDATE_ECG_LIST_FILTERS,
    RESET_ECG_LIST_FILTERS
} from 'actions/ActionTypes';

import { getUpdatedFilters } from 'utils/ecg/ecgUtil';

const INITIAL_STATE = {
    ecgRecordingList: null,
    ecgRecordingListFetching: '',
    ecgRecordingListSuccess: false,
    ecgRecordingListFail: false,
    ecgRecordingListErrorType: null,
    nextToken: null,
    ecgRecordingDeleting: false,
    ecgRecordingDeleteSuccess: false,
    ecgRecordingDeleteFail: false,
    filters: {
        symptoms: [],
        resultTypes: [],
        dates: {
            fromDate: '',
            toDate: ''
        }
    }
};

const ecgRecordingListFetching = (state, action) => ({
    ...state,
    ecgRecordingListFetching: action.loadingType,
    ecgRecordingListSuccess: false,
    ecgRecordingListFail: false,
    ecgRecordingListErrorType: null
});

const ecgRecordingListFetchFinished = (isSuccess) => (state, action) => {
    const { content, next, errorType } = action && action.data ? action.data : {};
    return {
        ...state,
        ecgRecordingList: content || [],
        ecgRecordingListFetching: '',
        ecgRecordingListSuccess: isSuccess,
        ecgRecordingListFail: !isSuccess,
        ecgRecordingListErrorType: !isSuccess && errorType ? errorType : null,
        nextToken: next,
        ecgRecordingDeleting: false,
        ecgRecordingDeleteSuccess: false,
        ecgRecordingDeleteFail: false
    };
};

const ecgRecordingListFetchMoreFinished = (isSuccess) => (state, action) => {
    const { content, next, errorType } = action && action.data ? action.data : {};
    let updatedList = [];
    if (state.ecgRecordingList && state.ecgRecordingList.length > 0) {
        updatedList = isSuccess ? state.ecgRecordingList.concat(content) : state.ecgRecordingList || [];
    } else {
        updatedList = isSuccess ? content : [];
    }
    return {
        ...state,
        ecgRecordingList: updatedList,
        ecgRecordingListFetching: '',
        ecgRecordingListSuccess: isSuccess,
        ecgRecordingListFail: !isSuccess,
        ecgRecordingListErrorType: !isSuccess && errorType ? errorType : null,
        nextToken: next
    };
};

const ecgRecordingDeleting = (state, action) => {
    const ecgId = action.payload;

    if (!state.ecgRecordings || !state.ecgRecordings[ecgId]) {
        return state;
    }

    return {
        ...state,
        ecgRecordingDeleting: true
    };
};

const ecgRecordingDeleteFinished = (isSuccess) => (state, action) => {
    const ecgId = action.payload;
    if (!state.ecgRecordingList) {
        return state;
    }
    const newEcgRecordingList = state.ecgRecordingList.filter((listItem) => listItem.detailId !== ecgId);
    return {
        ...state,
        ecgRecordingList: newEcgRecordingList,
        ecgRecordingDeleting: false,
        ecgRecordingDeleteSuccess: isSuccess,
        ecgRecordingDeleteFail: !isSuccess
    };
};

const ecgFiltersUpdated = (state, action) => {
    const { filterType, filterValue } = action.payload;
    const newFilters = getUpdatedFilters(state.filters, filterType, filterValue);

    return {
        ...state,
        filters: newFilters,
        nextToken: INITIAL_STATE.nextToken // when the filter changes then the pagination/token state must be reset
    };
};

const ecgFiltersReset = (state) => ({
    ...state,
    filters: { ...INITIAL_STATE.filters },
    nextToken: INITIAL_STATE.nextToken // when the filter changes then the pagination/token state must be reset
});

export const isEcgRecordingListFetching = (state) => state.ecgRecordingList.ecgRecordingListFetching;
export const isEcgRecordingListSuccess = (state) => state.ecgRecordingList.ecgRecordingListSuccess;
export const isEcgRecordingListFail = (state) => state.ecgRecordingList.ecgRecordingListFail;
export const getEcgRecordingList = (state) => state.ecgRecordingList.ecgRecordingList;
export const getEcgRecordingListErrorType = (state) => state.ecgRecordingList.ecgRecordingListErrorType;

export const getNextToken = (state) => state.ecgRecordingList.nextToken;

export const isEcgRecordingDeleting = (state) => state.ecgRecordingList.ecgRecordingDeleting;
export const isEcgRecordingDeleteSuccess = (state) => state.ecgRecordingList.ecgRecordingDeleteSuccess;
export const ecgRecordingDeleteFail = (state) => state.ecgRecordingList.ecgRecordingDeleteFail;

export const getEcgActiveFilters = (state) => state.ecgRecordingList.filters;

const handlers = {
    [FETCH_ECG_RECORDING_LIST_START]: ecgRecordingListFetching,
    [FETCH_ECG_RECORDING_LIST_SUCCESS]: ecgRecordingListFetchFinished(true),
    [FETCH_ECG_RECORDING_LIST_FAIL]: ecgRecordingListFetchFinished(false),
    [FETCH_MORE_ECG_RECORDING_LIST_SUCCESS]: ecgRecordingListFetchMoreFinished(true),
    [DELETE_ECG_RECORDING_START]: ecgRecordingDeleting,
    [DELETE_ECG_RECORDING_SUCCESS]: ecgRecordingDeleteFinished(true),
    [DELETE_ECG_RECORDING_FAIL]: ecgRecordingDeleteFinished(false),
    [UPDATE_ECG_LIST_FILTERS]: ecgFiltersUpdated,
    [RESET_ECG_LIST_FILTERS]: ecgFiltersReset
};

export default function ecgRecordingList(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
